import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class DockAppointments_ds_dock_appointment_activity_listService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { dockAppointmentId: number, $top?: number, $skip?: number }): Promise<{ result?: { dockAppointmentId?: number, activityTitle?: string, activityDetails?: string, activityUser?: string, activityStyle?: string, activityDate?: string }[], totalCount?: number }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.dockAppointmentId)) {
      missingRequiredInParams.push('\'dockAppointmentId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/DockAppointments/datasources/ds_dock_appointment_activity_list/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { dockAppointmentId?: number, $keys: number[] }): Promise<{ result?: { dockAppointmentId?: number, activityTitle?: string, activityDetails?: string, activityUser?: string, activityStyle?: string, activityDate?: string }[] }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/DockAppointments/datasources/ds_dock_appointment_activity_list/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

    
    hasMissingRequiredInParams(inParams: { 
      dockAppointmentId: number    }) {
        if(isNil(inParams.dockAppointmentId)) {
          return true; 
        }
      return false;
    }
}
